import * as buffer from 'buffer';
import ReactDOM from 'react-dom';
import './layout/darkTheme.css';
import ThemeConfig from './theme';
window.Buffer = buffer.Buffer;

import 'react-phone-number-input/style.css';
import { Provider } from 'react-redux';

import { RootRoute } from './routes';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import { ConnectedRouter } from 'connected-react-router';
import { ToastContainer } from 'react-toastify';
import history from './history';
import './i18n.js';
import './index.css';
import store from './store';
import DateProvider from './providers/DateProvider.jsx';

function App() {
    return (
        <Provider store={store}>
            <ThemeConfig>
                <ConnectedRouter history={history}>
                    <DateProvider>
                        <RootRoute />
                    </DateProvider>
                </ConnectedRouter>
                <ToastContainer
                    stacked
                    position="top-center"
                    autoClose={4000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
            </ThemeConfig>
        </Provider>
    );
}

ReactDOM.render(<App />, document.getElementById('root'));

if (process.env.REACT_APP_ENABLE_SERVICE_WORKER === 'true') {
    serviceWorkerRegistration.register();
} else {
    serviceWorkerRegistration.unregister();
}
